import { Button } from "@/components/ui/button/button";

type Props = {
	onClickCallback: () => void;
};

export const FinishButton = ({ onClickCallback }: Props) => {
	return (
		<Button variant="outline" type="button" size="lg" onClick={onClickCallback}>
			完了
		</Button>
	);
};
